<div *ngIf="formGroup" class="input__container" [formGroup]="formGroup">
  <label
    class="label__input__lovers"
    [ngClass]="{ disabled: disabled }"
    [class.label__input__lovers-floating]="
      formGroup.get(controlName)?.value || isInputFocused
    "
    [for]="idCampo"
    >{{ label }}</label
  >
  <select
    class="select__lovers"
    [ngClass]="{
      'error-border':
        formGroup.get(controlName).invalid &&
        formGroup.get(controlName).errors &&
        (formGroup.get(controlName).dirty ||
          formGroup.get(controlName).touched),
      disabled: disabled
    }"
    [name]="controlName"
    [formControlName]="controlName"
    [tabindex]="tab"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
    [id]="idCampo"
  >
    <option *ngFor="let opcao of valores" [value]="opcao.value">
      {{ opcao.label }}
    </option>
  </select>
</div>

<div
  *ngIf="
    formGroup.get(controlName).invalid &&
    formGroup.get(controlName).errors &&
    (formGroup.get(controlName).dirty || formGroup.get(controlName).touched)
  "
  class="mensagem__erro"
>
  Campo obrigatório!
</div>

<div *ngIf="mensagemGenerica" class="mensagem__generica">
  {{ mensagemGenerica }}
</div>
